<template>
    <div class="header" @click="homeClick">
        <div class="left">
          		<a href="http://riis.skr.u-ryukyu.ac.jp/resources/"><img src="../assets/img/logo.png"  alt="ロゴ" width="45px"></a>
        </div>
        <div class="right" style="margin:auto;">
            	<a href="http://riis.skr.u-ryukyu.ac.jp/resources/"><h1 style="margin:auto;">研究資源データベース</h1></a>
        </div>
        <div class="topreturn">
           <router-link to='/'>
          <div>&#8811; TOPへ戻る</div>
           </router-link>
        </div>        
    </div>
</template>
<style>
.header {
  cursor: pointer;
}
</style>
<script>
export default {
  name: 'Header',
  methods: {
    /**
     * HOMEのクリック処理
     */
    homeClick() {
      //階層は未選択の状態にする
      //this.$store.dispatch('upOpenMenuId', '')
      this.$store.dispatch('delAllOpenMenuId', '')
      this.$store.dispatch('delAllOpenMenuId2', '')
      this.$store.dispatch('upSelMenuId', '')
      this.$store.dispatch('upSelMenuId2', '')

      this.$router.push(`/`)
    }
  }
}
</script>
